import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import {
    isEnabledForFrontierCopilotAudience,
    type FrontierFlightConfig,
} from './isEnabledForFrontierCopilotAudience';

const labsBarFrontierFlights: FrontierFlightConfig = {
    publicFlight: 'cal-ai-labs-bar-frontier-public',
    privateTapFlight: 'cal-ai-labs-bar-frontier-private-tap',
    privateStagingFlight: 'cal-ai-labs-bar-frontier-private-staging',
    privateInfluencerFlight: 'cal-ai-labs-bar-frontier-private-influencer',
};

/**
 * Returns true if the Calendar AI Labs Bar is enabled for the given mailbox.
 *
 * Enabled via either:
 *  - Standard path: global flight 'cal-ai-labs-bar'
 *  - Frontier path: user is enrolled in a Frontier audience tier and the corresponding tier flight is on
 *
 * Unlike AutoRoom Booking and Managed Events, there is no service capability check on the standard
 * path. The Frontier path implicitly requires a Copilot license via isEnabledForFrontierCopilotAudience.
 *
 * @param mailboxInfo Mailbox info for the account to check
 * @returns true if the feature is enabled, false otherwise
 */
export function isCalendarAILabsBarEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isGlobalFeatureEnabled('cal-ai-labs-bar') ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, labsBarFrontierFlights)
    );
}
